<template>
  <ExtracadabraModal
    v-model:opened="internalOpen"
    :header="{ bgColor: 'primary', textColor: 'white', icon }"
    :title="title"
    :body="{ class: 'text-center' }"
    :footer="{ class: 'text-center' }"
    :quasar-props="{
      maximized: false,
    }"
    size="sm"
  >
    <template #body>
      <slot name="body" />
    </template>
    <template #footer>
      <QBtn v-close-popup class="btn-large q-mb-sm text-underline" flat no-caps :label="$t('CORE.BUTTONS.@CANCEL')" />
      <QBtn
        v-close-popup
        type="button"
        no-caps
        color="secondary"
        :label="$t('CORE.BUTTONS.@CONFIRM')"
        class="btn-large"
        @click="$emit('confirm-action')"
      />
    </template>
  </ExtracadabraModal>
</template>

<script>
  import ExtracadabraModal from "./ExtracadabraModal.component.vue";

  export default {
    components: {
      ExtracadabraModal,
    },
    props: {
      title: {
        type: String,
        default: "",
      },
      icon: {
        type: String,
        default: "fad fa-circle-exclamation",
      },
      opened: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["confirm-action", "update:opened"],
    computed: {
      internalOpen: {
        get() {
          return this.opened;
        },
        set(value) {
          this.$emit("update:opened", value);
        },
      },
    },
  };
</script>
